export default {
  'app.pwa.offline': 'You are offline now',
  'app.pwa.serviceworker.updated': 'New content is available',
  'app.pwa.serviceworker.updated.hint':
    'Please press the "Refresh" button to reload current page',
  'app.pwa.serviceworker.updated.ok': 'Refresh',
  'app.updateCheck.title': 'Update Check',
  'app.updateCheck.backend': 'Backend',
  'app.updateCheck.frontend': 'Frontend',
  'app.updateCheck.upToDate': 'Up to date',
  'app.updateCheck.newVersionAvailable':
    '{count} new update{count, plural, =1 { is} other {s are}} available',
  'app.updateCheck.allUpToDate': 'All components are up to date',
  'app.updateCheck.viewRelease': 'View Release',
  'app.updateCheck.recheck': 'Recheck',
  'app.updateCheck.close': 'Close',
  'app.updateCheck.failed': 'Update check failed, please try again later',
};
